enum EndpointBindingType {
  unknown = "unknown",
  redirect = "redirect",
  post = "post",
  soap = "soap",
}

interface SSOConfig {
  clientId: number;
  isEnabled: boolean;
  schemeName: string;
  displayName: string;
  ssoType: SSOType;
  idPOptions: SSOIdPOptions;
  spOptions: SSOSpOptions;
  callbackPath: string;
  nameIdentifierClaimType: string;
  emailClaimType: string;
}

interface SSOIdPOptions {
  entityId: string;
  singleSignOnEndpoint: string;
  signOnEndpointBindingType: EndpointBindingType;
  signingCertificatesBase64: string[];
}

interface SSOSpOptions {
  entityId: string;
  requireEncryptedAssertions: boolean;
  encryptionCertificateBase64: string;
  signAuthenticationRequests: boolean;
  signingCertificateBase64: string;
  metadataPath: string;
}

enum SSOType {
  Unknown = "Unknown",
  SAML = "SAML",
}

export {
  EndpointBindingType,
  SSOConfig,
  SSOIdPOptions,
  SSOSpOptions,
  SSOType,
};
